/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Schoolname_Max_Beckmann_Schule4Inputs */

const en__field__enum_schoolname_max_beckmann_schule4 = /** @type {(inputs: _Field__Enum_Schoolname_Max_Beckmann_Schule4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frankfurt`)
};

const de__field__enum_schoolname_max_beckmann_schule4 = /** @type {(inputs: _Field__Enum_Schoolname_Max_Beckmann_Schule4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max-Beckmann-Schule`)
};

/**
* | output |
* | --- |
* | "Frankfurt" |
*
* @param {_Field__Enum_Schoolname_Max_Beckmann_Schule4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_schoolname_max_beckmann_schule4 = /** @type {((inputs?: _Field__Enum_Schoolname_Max_Beckmann_Schule4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Schoolname_Max_Beckmann_Schule4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_schoolname_max_beckmann_schule4(inputs)
	return de__field__enum_schoolname_max_beckmann_schule4(inputs)
});
export { _field__enum_schoolname_max_beckmann_schule4 as "_field__enum_schoolName_Max_Beckmann_Schule" }